const data = {
  id: 1,
  title: 'Choose the antonym of the underlined word.',
  subTitle: 'Chọn từ trái nghĩa của từ được gạch chân.',
  question: 'Driving fast is dangerous.',
  focusedWords: ['dangerous'],
  answers: [
    { id: 1, answer: 'crowded', isCorrect: false },
    { id: 2, answer: 'cheap', isCorrect: false },
    { id: 3, answer: 'clean', isCorrect: false },
    { id: 4, answer: 'safe', isCorrect: true },
  ],
};

export default data;
